/**
 * 워크스페이스 기준 사업 연도(specs/032) — 사용자가 **명시적으로 고른 연도만** 기억한다(FR-015).
 * null = "최근 연도 자동" — 서버 기본 연도를 따라가 새 연도 데이터가 올라오면 자연 전환된다.
 * 저장소 접근 실패(사생활 보호 창·차단)는 persist 가 삼키고 null 로 동작한다 — 주소의 `year` 만으로도 화면은 동작한다.
 */
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface ProgramYearState {
  explicitYear: null | number;
  setExplicitYear: (year: number) => void;
  clearExplicitYear: () => void;
}

export const PROGRAM_YEAR_STORAGE_KEY = 'ws.programYear';

export const useProgramYearStore = create<ProgramYearState>()(
  persist(
    (set) => ({
      explicitYear: null,
      setExplicitYear: (year) => set({ explicitYear: year }),
      clearExplicitYear: () => set({ explicitYear: null }),
    }),
    {
      name: PROGRAM_YEAR_STORAGE_KEY,
      version: 1,
      partialize: ({ explicitYear }) => ({ explicitYear }),
      // 형식이 틀린 값(수동 편집 등)은 버린다 — 목록 밖 연도 정리는 WorkspaceYearSync 가 맡는다
      merge: (persisted, current) => {
        const year = (persisted as Partial<ProgramYearState> | undefined)?.explicitYear;
        return {
          ...current,
          explicitYear: Number.isInteger(year) && (year as number) > 0 ? (year as number) : null,
        };
      },
    },
  ),
);
